var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/sold") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/sold",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C12.5522847,0 13,0.44771525 13,1 L13,4 L17,4 C17.5522847,4 18,4.44771525 18,5 C18,5.55228475 17.5522847,6 17,6 L13,6 L13,11 L14.5,11 C16.9852813,11 19,13.0147187 19,15.5 C19,17.9852813 16.9852813,20 14.5,20 L13,20 L13,23 C13,23.5522847 12.5522847,24 12,24 C11.4477153,24 11,23.5522847 11,23 L11,20 L6,20 C5.44771525,20 5,19.5522847 5,19 C5,18.4477153 5.44771525,18 6,18 L11,18 L11,13 L9.5,13 C7.01471863,13 5,10.9852814 5,8.5 C5,6.01471863 7.01471863,4 9.5,4 L11,4 L11,1 C11,0.44771525 11.4477153,0 12,0 Z M13,18 L14.5,18 C15.8807118,18 17,16.8807118 17,15.5 C17,14.1192882 15.8807118,13 14.5,13 L13,13 L13,18 Z M11,11 L11,6 L9.5,6 C8.11928813,6 7,7.11928813 7,8.5 C7,9.88071187 8.11928813,11 9.5,11 L11,11 Z",
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSold);
export default __webpack_public_path__ + "static/media/sold.13e7d4f6568bf2992859eef2b10e7c6d.svg";
export { ForwardRef as ReactComponent };